const actions = {
  SET_STATE: 'disputes/SET_STATE',
  FETCH_ALL_DISPUTES: 'disputes/FETCH_ALL_DISPUTES',
  FETCH_DISPUTE: 'disputes/FETCH_DISPUTE',
  MANAGE_DISPUTE: 'disputes/MANAGE_DISPUTE',
}

export default actions
